import CloseIcon from "@mui/icons-material/Close";
import { ReactNode } from "react";
import { formatDateTimeFromEpoch } from "../../utils/helpers";
import { TextWrap } from "../Grid/Grid.styles";
import {
  BoldText,
  EditOrderCloseButton,
  EditOrderCountdownPill,
  EditOrderDialogTitle,
  EditOrderHeader,
  NewReqOrderIdWrapper,
  NewReqOrderInfoContainer,
} from "./NewRequisition.styles";
import { formatEditWindowTimeRemaining } from "./orderEdit";
import { NewRequisitionType } from "./types";

export const OrderDetailsDialogTitle: React.FC<{
  id: string;
  onClose: () => void;
  title?: string;
  disabled?: boolean;
  children?: ReactNode;
}> = ({ id, onClose, children, title = "ORDER DETAILS", disabled }) => (
  <EditOrderDialogTitle id={id}>
    <EditOrderHeader>
      <TextWrap sx={{ overflowWrap: "anywhere", minWidth: 0 }}>
        {title}
      </TextWrap>
      {children}
    </EditOrderHeader>
    <EditOrderCloseButton
      aria-label="close"
      disabled={disabled}
      onClick={onClose}
    >
      <CloseIcon />
    </EditOrderCloseButton>
  </EditOrderDialogTitle>
);

export const EditWindowCountdown: React.FC<{ expiresAt: string }> = ({
  expiresAt,
}) => (
  <EditOrderCountdownPill>
    Editable for the next{" "}
    <strong>{formatEditWindowTimeRemaining(expiresAt)}</strong>
  </EditOrderCountdownPill>
);

export const OrderDetailsMetadata: React.FC<{
  orderNumber?: string;
  created?: Pick<
    NewRequisitionType,
    "created_at" | "provider_full_name"
  > | null;
}> = ({ orderNumber, created }) => (
  <NewReqOrderInfoContainer>
    <NewReqOrderIdWrapper>
      Order Number: <BoldText>{orderNumber}</BoldText>
    </NewReqOrderIdWrapper>
    {created && (
      <>
        <NewReqOrderIdWrapper>
          Created At:{" "}
          <BoldText>{formatDateTimeFromEpoch(created.created_at)}</BoldText>
        </NewReqOrderIdWrapper>
        <NewReqOrderIdWrapper>
          Created By: <BoldText>{created.provider_full_name}</BoldText>
        </NewReqOrderIdWrapper>
      </>
    )}
  </NewReqOrderInfoContainer>
);
